import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import React, { useEffect } from 'react';
import { Translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { deleteEntity, getEntity } from './truck-implement.reducer';

export const TruckImplementDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const truckImplementEntity = useAppSelector(state => state.truckImplement.entity);
  const updateSuccess = useAppSelector(state => state.truckImplement.updateSuccess);
  const errorMessage = useAppSelector(state => state.truckImplement.errorMessage);

  const handleClose = () => {
    props.history.goBack();
  };

  const errorDeleting = () => {
    props.history.goBack();

    return toast.error(<Translate contentKey="fleetSenseApp.truckImplement.error" />);
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (errorMessage) {
      errorDeleting();
    }
  }, [errorMessage]);

  const confirmDelete = () => {
    dispatch(deleteEntity(truckImplementEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose} zIndex={9999}>
      <ModalHeader toggle={handleClose} data-cy="truckImplementDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.truckImplement.delete.question">
        <Translate contentKey="fleetSenseApp.truckImplement.delete.question" interpolate={{ id: truckImplementEntity.licensePlate }}>
          Are you sure you want to delete this TruckImplement?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="app-confirm-delete-truckImplement" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TruckImplementDeleteDialog;
